import { App} from 'antd'
import { useBnsGoodsDelMutation,} from '../../store/BnsKeJiApi';
import {DeleteOutlined,} from '@ant-design/icons';
function ProjectDel(props) {
    const {modal,message} = App.useApp();
    const [submitDel] = useBnsGoodsDelMutation()   
    return (
        <a onClick={() => {
            modal.confirm({
                title: '确定删除吗?',
                content: '删除后不能恢复',
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk() {
                    submitDel({bg_id:props.bg_id}).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.info('删除成功！');
                        }
                        if (res.data.Status === "fail") {
                            message.error('删除失败！'+res.data.Message)
                        }
                    })
                },
                onCancel() {
                    // console.log('Cancel');
                },
            }); 
        }}><DeleteOutlined /> 删除项目</a>
    )
}

export default ProjectDel